'use client'

import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet'
import { useSearchState } from '@/lib/search-state'
import { ExternalLink, MenuIcon, Search } from 'lucide-react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useState } from 'react'
import { HEADER_MOBILE_LINKS } from '../../constants'
import BrandLogo from '../BrandLogo'

function SocialDrawer() {
  const [open, setOpen] = useState(false)
  const pathname = usePathname()

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="supra-mobile-menu-btn h-9 py-2"
        aria-label="More links"
        aria-expanded={open}
      >
        <span className="pointer-events-none inline-flex">
          <MenuIcon size={18} />
        </span>
      </button>
      <SheetContent side="right" aria-describedby={undefined} className="supra-mobile-drawer-content gap-0 p-0">
        <SheetTitle className="supra-mobile-drawer-title">
          <BrandLogo />
          <span className="sr-only">Menu</span>
        </SheetTitle>
        <nav className="supra-mobile-drawer-nav">
          {HEADER_MOBILE_LINKS.map((link, index: number) => {
            const Icon = link.icon
            const isActive = pathname === link.href || pathname.includes(link.href)
            const isFirstExternal = link.external && !HEADER_MOBILE_LINKS[index - 1]?.external
            return (
              <div key={link.href}>
                {isFirstExternal && <div className="supra-mobile-drawer-section-label">Resources</div>}
                <Link
                  href={link.href}
                  onClick={() => setOpen(false)}
                  target={link.external ? '_blank' : '_self'}
                  rel="noopener noreferrer"
                  aria-current={isActive ? 'page' : undefined}
                  className={`supra-mobile-drawer-item${isActive ? ' is-active' : ''}`}
                >
                  {Icon && (
                    <span className="supra-mobile-drawer-item-icon">
                      <Icon size={17} strokeWidth={1.9} />
                    </span>
                  )}
                  <span className="flex-1">{link.label}</span>
                  {link.external && <ExternalLink size={14} className="supra-mobile-drawer-item-ext" />}
                </Link>
              </div>
            )
          })}
        </nav>
      </SheetContent>
    </Sheet>
  )
}

export function MobileActions() {
  const { open: searchOpen, toggle } = useSearchState()

  return (
    <div
      className={`flex items-center gap-2 md:hidden supra-mobile-actions${searchOpen ? ' supra-mobile-actions--hidden' : ''}`}
    >
      <button type="button" onClick={toggle} className="supra-mobile-search-btn h-7.75" aria-label="Open search">
        <Search size={18} />
      </button>
      <SocialDrawer />
    </div>
  )
}
